{
  "title": "Shadow Of Moil",
  "source": "Xanathar's Guide to Everything",
  "levelAndSchool": "4th-level necromancy",
  "level": 4,
  "castingTime": "1 action",
  "range": "Self",
  "components": "V, S, M (an undead eyeball encased in a gem worth at least 150 gp)",
  "duration": "Concentration, up to 1 minute",
  "description": [
    "Flame-like shadows wreathe your body until the spell ends, causing you to become heavily obscured to others. The shadows turn dim light within 10 feet of you into darkness, and bright light in the same area to dim light.",
    "Until the spell ends, you have resistance to radiant damage. In addition, whenever a creature within 10 feet of you hits you with an attack, the shadows lash out at that creature, dealing it 2d8 necrotic damage."
  ],
  "spellLists": ["warlock"]
}
